import { render, staticRenderFns } from "./TeamSelector.vue?vue&type=template&id=3af39ae3&"
import script from "./TeamSelector.vue?vue&type=script&lang=js&"
export * from "./TeamSelector.vue?vue&type=script&lang=js&"
import style0 from "./TeamSelector.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports